export interface ClientPortalRouteContext {
  entityId: string;
}

export function getClientPortalContextFromPathname(
  pathname: string | null | undefined,
): ClientPortalRouteContext | null {
  if (!pathname) {
    return null;
  }

  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'client-portal') {
    return null;
  }

  const entityId = segments[1];
  if (!entityId) {
    return null;
  }

  return { entityId };
}

export function getCurrentClientPortalContext(): ClientPortalRouteContext | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return getClientPortalContextFromPathname(window.location.pathname);
}
